export function ValueInPropertiesOrErrorsHasChanged(keysObject: {[keys: string]: string}, newProps: {properties: any, errors: {}}, props: {properties: any, errors: {}}) {
    return  newProps.errors !== props.errors || Object.keys(keysObject).some(p => newProps.properties[p] !== props.properties[p]);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/utils/ShouldUpdate/ValueInPropertiesHasChanged.ts